import { styled } from 'styled-components';

const InputSC = styled.input`
  all: initial;
  display: inline-block;
  width: inherit;
  padding: 0 0.9375rem;
  font-family: ${(props) => props.theme.fontFamily.montserrat};
  font-size: 2.375rem;
  font-weight: 700;
  line-height: 2.875rem;
  text-align: center;
  box-sizing: border-box;
  caret-color: transparent;

  &::placeholder {
    font-size: 3.125rem;
    line-height: 2.875rem;
    color: #000;
  }

  &:focus::placeholder {
    color: transparent;
  }

  &:focus + span {
    width: 2.5rem;
  }

  &::selection {
    background: none;
  }
`;

const WrapperSC = styled.span`
  width: inherit;
  display: inline-block;
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 1px;
    height: 2.125rem;
    background: ${(props) => props.theme.colors.oxfordBlue[30]};
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }
`;

const BorderSC = styled.span`
  display: inline-block;
  width: 0;
  height: 1px;
  background: ${(props) => props.theme.colors.oxfordBlue[100]};
  position: absolute;
  bottom: -5px;
  left: 50%;
  transition: all ease-in-out 0.15s;
  transform: translate(-50%);
`;

type CodeInputProps = {
  codeNumber: string;
  handleCodeChange: (event: React.FormEvent<HTMLInputElement>, value: string, index: number) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  index: number;
};

export const VerificationCodeInput = ({ codeNumber, handleCodeChange, handleKeyDown, index }: CodeInputProps) => {
  function handleInput(event: React.FormEvent<HTMLInputElement>) {
    const target = event.currentTarget as HTMLInputElement;
    const { value } = target;

    // regex to match strings containing only digits (0-9)
    const regex = /^\d*$/;
    const isValid = regex.test(value);

    if (isValid) {
      handleCodeChange(event, value, index);
    }
  }

  function handleFTargetFocus<T extends React.SyntheticEvent>(event: T) {
    const target = event.currentTarget as HTMLInputElement;

    target.select();
  }

  return (
    <WrapperSC>
      <InputSC
        aria-describedby="pinCodeInstructions"
        aria-label={`Digit ${index + 1}`}
        inputMode="numeric"
        maxLength={1}
        onFocus={handleFTargetFocus}
        onInput={handleInput}
        onKeyDown={handleKeyDown}
        onKeyUp={handleFTargetFocus}
        placeholder="•"
        type="text"
        value={codeNumber}
      />
      <BorderSC />
    </WrapperSC>
  );
};
